/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * NXT48
 * API documentation generated from Zod schemas
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  TrackingTrack200,
  TrackingTrack400,
  TrackingTrackBody
} from '../nxt48.schemas';

import { customInstance } from '../../orval-fetcher';




/**
 * Track an event
 * @summary Track Event
 */
export const trackingTrack = (
    trackingTrackBody: TrackingTrackBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TrackingTrack200>(
      {url: `/tracking/track`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: trackingTrackBody, signal
    },
      );
    }
  


export const getTrackingTrackMutationOptions = <TError = TrackingTrack400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trackingTrack>>, TError,{data: TrackingTrackBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof trackingTrack>>, TError,{data: TrackingTrackBody}, TContext> => {

const mutationKey = ['trackingTrack'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof trackingTrack>>, {data: TrackingTrackBody}> = (props) => {
          const {data} = props ?? {};

          return  trackingTrack(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TrackingTrackMutationResult = NonNullable<Awaited<ReturnType<typeof trackingTrack>>>
    export type TrackingTrackMutationBody = TrackingTrackBody
    export type TrackingTrackMutationError = TrackingTrack400

    /**
 * @summary Track Event
 */
export const useTrackingTrack = <TError = TrackingTrack400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trackingTrack>>, TError,{data: TrackingTrackBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof trackingTrack>>,
        TError,
        {data: TrackingTrackBody},
        TContext
      > => {

      const mutationOptions = getTrackingTrackMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    